<template>
  <div class="page_bd Solution-area">
    <secBanner></secBanner>
    <div class="breadcrumb-nav">
      <div class="container">
        您现在的位置：
        <router-link to="/">首页</router-link>
        >
        <router-link :to="{ path: '/solution'}">
          解决方案
        </router-link>
        >
        <span v-if="activeIndex > -1 && solutionTypes.length > 0">{{ activeIndex > -1 ? solutionTypes[activeIndex].name:'解决方案' }}</span>
      </div>
    </div>
    <div class="container content-area" v-if="solutionTypes.length > 0">
      <div class="tabs" :style="'width:' + solutionTypes.length * 160 + 'px;'">
        <div
          class="tab"
          :class="{ active: activeIndex == index }"
          :style="'width:' + 100 / solutionTypes.length + '%;'"
          @click="
            activeIndex = index;
            getArticleList();
          "
          v-for="(item, index) in solutionTypes"
          :key="index"
        >
          {{ item.name }}
        </div>

        <!-- <router-link
          class="tab"
          :class="{ active: activeIndex == index }"
          :style="'width:' + 100 / solutionTypes.length + '%;'"
          :to="{ path: '/solution', query: { tab: index } }"
          v-for="(item,index) in solutionTypes" :key="index"
        >
          {{item.name}}
        </router-link> -->
      </div>
      <div class="lead">
        {{ activeIndex > -1 ? solutionTypes[activeIndex].name:'解决方案' }}
      </div>
      <div class="list">
        <ul>
          <li v-for="(item, index) in dataList" :key="index">
            <router-link class="single" :to="{ name: 'NewsDetail', query: { type: item.classifyid, id: item.id,pid:item.classify_parent_id } }">
              <div class="img"><img :src="$imgBaseUrl + item.article_img" alt="" /></div>
              <div class="info">
                <div class="title ellipsis">{{ item.title }}</div>
                <div class="intro ellipsis2">{{ item.introduce }}</div>
                <div class="time">{{ item.created_time }}</div>
              </div>
            </router-link>
          </li>
        </ul>

        <pagination
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="total < listQuery.limit"
          @pagination="getArticleList"
        />
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import secBanner from '@/components/assembly/sec-banner'
import Pagination from '@/components/assembly/pagination'
export default {
  data () {
    return {
      dataList: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 9
      },
      activeIndex: this.$route.query.tab || 0,
      solutionTypes: []
    }
  },
  watch: {
    $route (to, from) {
      // data数据操作
      if (to.query.tab !== from.query.tab) {
        this.activeIndex = this.$route.query.tab
        this.getArticleList()
      }
    }
  },
  mounted () {
    this.getArticleClassify()
  },
  methods: {
    getArticleList () {
      this.$https
        .fetchPost('/Article/article_list', {
          classifyid: this.solutionTypes[this.activeIndex].id,
          page: 1,
          limit: 10
        })
        .then(res => {
          // console.log(res.data.data)
          this.dataList = res.data
          this.total = res.count
        })
        .catch(err => {
          console.log(err)
        })
    },
    getArticleClassify () {
      this.$https
        .fetchPost('/Article/classify_list', {
          parent_id: 36
        })
        .then(res => {
          // console.log(res)
          this.solutionTypes = res.data
          this.getArticleList()
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  components: {
    secBanner,
    Pagination
  }
}
</script>
<style lang="less">
.Solution-area {
  .tabs {
    width: 320px;
    .tab {
      width: 50%;
    }
  }
  .list {
    .single {
      padding: 30px 0;
      display: flex;
      border-bottom: 1px solid rgba(224, 224, 224, 1);
      &:hover{
        // background: #f2f2f2;
        .title{
          color: #028238;
        }
      }
      .img {
        // width: 168px;
        // height: 114px;
        img {
          width: 168px;
          height: 114px;
        }
      }
      .info {
        flex: 1;
        margin-left: 20px;
      }
      .title {
        font-family: MicrosoftYaHei-Bold;
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        line-height: 22px;
        letter-spacing: 0px;
        color: rgba(102, 102, 102, 1);
        cursor: pointer;
      }
      .intro {
        margin: 10px 0 5px;
        height: 44px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 22px;
        letter-spacing: 0px;
        color: rgba(153, 153, 153, 1);
      }
      .time {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 22px;
        letter-spacing: 0px;
        color: rgba(153, 153, 153, 1);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/solution.vue